/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ڪل",
        "0": "اڄ",
        "1": "سڀاڻي",
        "future": {
          "one": "{0} ڏينهن ۾",
          "other": "{0} ڏينهن ۾"
        },
        "past": {
          "one": "{0} ڏينهن پهرين",
          "other": "{0} ڏينهن پهرين"
        }
      },
      "day-narrow": {
        "-1": "ڪل",
        "0": "اڄ",
        "1": "سڀاڻي",
        "future": {
          "one": "{0} ڏينهن ۾",
          "other": "{0} ڏينهن ۾"
        },
        "past": {
          "one": "{0} ڏينهن پهرين",
          "other": "{0} ڏينهن پهرين"
        }
      },
      "day-short": {
        "-1": "ڪل",
        "0": "اڄ",
        "1": "سڀاڻي",
        "future": {
          "one": "{0} ڏينهن ۾",
          "other": "{0} ڏينهن ۾"
        },
        "past": {
          "one": "{0} ڏينهن پهرين",
          "other": "{0} ڏينهن پهرين"
        }
      },
      "hour": {
        "0": "هن ڪلڪ",
        "future": {
          "one": "{0} ڪلاڪ ۾",
          "other": "{0} ڪلاڪ ۾"
        },
        "past": {
          "one": "{0} ڪلاڪ پهرين",
          "other": "{0} ڪلاڪ پهرين"
        }
      },
      "hour-narrow": {
        "0": "هن ڪلڪ",
        "future": {
          "one": "{0} ڪلاڪ ۾",
          "other": "{0} ڪلاڪ ۾"
        },
        "past": {
          "one": "{0} ڪلاڪ پهرين",
          "other": "{0} ڪلاڪ پهرين"
        }
      },
      "hour-short": {
        "0": "هن ڪلڪ",
        "future": {
          "one": "{0} ڪلاڪ ۾",
          "other": "{0} ڪلاڪ ۾"
        },
        "past": {
          "one": "{0} ڪلاڪ پهرين",
          "other": "{0} ڪلاڪ پهرين"
        }
      },
      "minute": {
        "0": "هن منٽ",
        "future": {
          "one": "{0} منٽن ۾",
          "other": "+{0} min"
        },
        "past": {
          "one": "{0} منٽ پهرين",
          "other": "{0} منٽ پهرين"
        }
      },
      "minute-narrow": {
        "0": "هن منٽ",
        "future": {
          "one": "{0} منٽن ۾",
          "other": "{0} منٽن ۾"
        },
        "past": {
          "one": "{0} منٽ پهرين",
          "other": "{0} منٽ پهرين"
        }
      },
      "minute-short": {
        "0": "هن منٽ",
        "future": {
          "one": "{0} منٽن ۾",
          "other": "{0} منٽن ۾"
        },
        "past": {
          "one": "{0} منٽ پهرين",
          "other": "{0} منٽ پهرين"
        }
      },
      "month": {
        "-1": "پوئين مهيني",
        "0": "هن مهيني",
        "1": "اڳين مهيني",
        "future": {
          "one": "{0} مهينن ۾",
          "other": "{0} مهينن ۾"
        },
        "past": {
          "one": "{0} مهينا پهرين",
          "other": "{0} مهينا پهرين"
        }
      },
      "month-narrow": {
        "-1": "پوئين مهيني",
        "0": "هن مهيني",
        "1": "اڳين مهيني",
        "future": {
          "one": "{0} مهينن ۾",
          "other": "{0} مهينن ۾"
        },
        "past": {
          "one": "{0} مهينا پهرين",
          "other": "{0} مهينا پهرين"
        }
      },
      "month-short": {
        "-1": "پوئين مهيني",
        "0": "هن مهيني",
        "1": "اڳين مهيني",
        "future": {
          "one": "{0} مهينن ۾",
          "other": "{0} مهينن ۾"
        },
        "past": {
          "one": "{0} مهينا پهرين",
          "other": "{0} مهينا پهرين"
        }
      },
      "nu": ["arab"],
      "quarter": {
        "-1": "پوئين ٽي ماهي",
        "0": "هن ٽي ماهي",
        "1": "اڳين ٽي ماهي",
        "future": {
          "one": "{0} ٽي ماهي ۾",
          "other": "{0} ٽي ماهي ۾"
        },
        "past": {
          "one": "{0} ٽي ماهي پهرين",
          "other": "{0} ٽي ماهي پهرين"
        }
      },
      "quarter-narrow": {
        "-1": "پوئين ٽي ماهي",
        "0": "هن ٽي ماهي",
        "1": "اڳين ٽي ماهي",
        "future": {
          "one": "{0} ٽي ماهي ۾",
          "other": "{0} ٽي ماهي ۾"
        },
        "past": {
          "one": "{0} ٽي ماهي پهرين",
          "other": "{0} ٽي ماهي پهرين"
        }
      },
      "quarter-short": {
        "-1": "پوئين ٽي ماهي",
        "0": "هن ٽي ماهي",
        "1": "اڳين ٽي ماهي",
        "future": {
          "one": "{0} ٽي ماهي ۾",
          "other": "{0} ٽي ماهي ۾"
        },
        "past": {
          "one": "{0} ٽي ماهي پهرين",
          "other": "{0} ٽي ماهي پهرين"
        }
      },
      "second": {
        "0": "هاڻي",
        "future": {
          "one": "{0} سيڪنڊن ۾",
          "other": "{0} سيڪنڊن ۾"
        },
        "past": {
          "one": "{0} سيڪنڊ پهرين",
          "other": "{0} سيڪنڊ پهرين"
        }
      },
      "second-narrow": {
        "0": "هاڻي",
        "future": {
          "one": "{0} سيڪنڊن ۾",
          "other": "{0} سيڪنڊن ۾"
        },
        "past": {
          "one": "{0} سيڪنڊ پهرين",
          "other": "{0} سيڪنڊ پهرين"
        }
      },
      "second-short": {
        "0": "هاڻي",
        "future": {
          "one": "{0} سيڪنڊن ۾",
          "other": "{0} سيڪنڊن ۾"
        },
        "past": {
          "one": "{0} سيڪنڊ پهرين",
          "other": "{0} سيڪنڊ پهرين"
        }
      },
      "week": {
        "-1": "پوئين هفتي",
        "0": "هن هفتي",
        "1": "اڳين هفتي",
        "future": {
          "one": "{0} هفتن ۾",
          "other": "{0} هفتن ۾"
        },
        "past": {
          "one": "{0} هفتا پهرين",
          "other": "{0} هفتا پهرين"
        }
      },
      "week-narrow": {
        "-1": "پوئين هفتي",
        "0": "هن هفتي",
        "1": "اڳين هفتي",
        "future": {
          "one": "{0} هفتن ۾",
          "other": "{0} هفتن ۾"
        },
        "past": {
          "one": "{0} هفتا پهرين",
          "other": "{0} هفتا پهرين"
        }
      },
      "week-short": {
        "-1": "پوئين هفتي",
        "0": "هن هفتي",
        "1": "اڳين هفتي",
        "future": {
          "one": "{0} هفتن ۾",
          "other": "{0} هفتن ۾"
        },
        "past": {
          "one": "{0} هفتا پهرين",
          "other": "{0} هفتا پهرين"
        }
      },
      "year": {
        "-1": "پويون سال",
        "0": "پويون سال",
        "1": "پويون سال",
        "future": {
          "one": "{0} سالن ۾",
          "other": "{0} سالن ۾"
        },
        "past": {
          "one": "{0} سال پهرين",
          "other": "{0} سال پهرين"
        }
      },
      "year-narrow": {
        "-1": "پوئين سال",
        "0": "هن سال",
        "1": "اڳيئن سال",
        "future": {
          "one": "{0} سالن ۾",
          "other": "{0} سالن ۾"
        },
        "past": {
          "one": "{0} سال پهرين",
          "other": "{0} سال پهرين"
        }
      },
      "year-short": {
        "-1": "پوئين سال",
        "0": "هن سال",
        "1": "اڳين سال",
        "future": {
          "one": "{0} سالن ۾",
          "other": "{0} سالن ۾"
        },
        "past": {
          "one": "{0} سال پهرين",
          "other": "{0} سال پهرين"
        }
      }
    },
    "locale": "sd-Arab"
  });
}